<template>
  <div class="home_area">
    <!--轮播-->
    <div class="home_swiper">
      <!--轮播//插件-->
      <div id="bigOne_swiper" class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in swiperData" :key="index">
            <img :src="item.url" alt="">
          </div>
        </div>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" style="color: #fff;"></div><!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
        <div class="swiper-button-next" style="color: #fff;"></div><!--右箭头。如果放置在swiper-container外面，需要自定义样式。-->
      </div>
    </div>
    <!--内容区-->
    <div class="home_content">
      <!--疾病百科-->
      <div v-if="0" class="home_disease">
        <!--头部-->
        <div class="home_disease_header">
          <div class="disease_header_text">
            <span>疾病</span>
            <div></div>
            <span>百科</span>
          </div>
          <div class="english_name">
            <div></div>
            <span>Diseases encyclopedia</span>
            <div></div>
          </div>
        </div>
        <!--导航-->
        <div class="home_disease_nav">
          <ul class="disease_navList">
            <li>最新</li>
            <li>内科</li>
            <li>外科</li>
            <li>妇产科</li>
            <li>儿科</li>
          </ul>
          <div class="disease_rightBut">
            <div>更多>></div>
          </div>
        </div>
        <!--card-->
        <div class="disease_card">
          <!--左-->
          <div class="disease_card_left">
            <!--图片区-->
            <div class="card_left_img">
              <div class="img_list">
                <img src="../assets/images/home/jibing1.jpeg" alt="">
                <div>孩子不吃饭怎么办</div>
              </div>
              <div class="img_list">
                <img src="../assets/images/home/jibing2.jpeg" alt="">
                <div>打一顿就好了</div>
              </div>
              <div class="img_list">
                <img src="../assets/images/home/jibing3.jpeg" alt="">
                <div>如果不行</div>
              </div>
              <div class="img_list">
                <img src="../assets/images/home/jibing4.jpeg" alt="">
                <div>那就打两顿</div>
              </div>
            </div>
            <!--列表区-->
            <div class="card_left_text">
              <div class="text_list">
                <div class="item_list">
                  <span>孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭？</span>
                  <div>2013-03-13</div>
                </div>
              </div>
              <div class="text_list">
                <div class="item_list">
                  <span>孩子为什么不吃饭？</span>
                  <div>2013-03-13</div>
                </div>
              </div>
            </div>
          </div>
          <!--中-->
          <div class="disease_card_center">
            <!--热门问答-->
            <div class="card_center_question">
              <div class="item_question">
                <div>肝炎的早期症状有哪些呢？</div>
                <span>肝炎流行季节或流行地区以及家中有急性肝炎患者时应高度警惕、时时提防。少数人在发病前曾有过类似“感冒”的症状少数人在发病前曾有过类似少数人在发病前曾有过类似少数人在发病前曾有过类似少数人在发病前曾有过类似少数人在发病前曾有过类似少数人在发病前曾有过类似少数人在发病前曾有过类似少数人在发病前曾有过类似</span>
              </div>
            </div>
            <!--问题列表-->
            <div class="card_hot_topic">
              <div class="hot_topic_list">
                <div class="item_topic_list">
                  <div class="hot_topic_text">
                    <div class="mask_box"></div>
                    <div class="Topic_text">没有钱的症状是什么？</div>
                  </div>
                  <div class="hot_topic_time">2020-03-16</div>
                </div>
              </div>
              <div class="hot_topic_list">
                <div class="item_topic_list">
                  <div class="hot_topic_text">
                    <div class="mask_box"></div>
                    <div class="Topic_text">没有钱的症状是什么？</div>
                  </div>
                  <div class="hot_topic_time">2020-03-16</div>
                </div>
              </div>
              <div class="hot_topic_list">
                <div class="item_topic_list">
                  <div class="hot_topic_text">
                    <div class="mask_box"></div>
                    <div class="Topic_text">没有钱的症状是什么？</div>
                  </div>
                  <div class="hot_topic_time">2020-03-16</div>
                </div>
              </div>
              <div class="hot_topic_list">
                <div class="item_topic_list">
                  <div class="hot_topic_text">
                    <div class="mask_box"></div>
                    <div class="Topic_text">没有钱的症状是什么？</div>
                  </div>
                  <div class="hot_topic_time">2020-03-16</div>
                </div>
              </div>
            </div>
            <!--列表区-->
            <div class="card_center_text">
              <div class="text_list">
                <div class="item_list">
                  <span>孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭孩子为什么不吃饭？</span>
                  <div>2013-03-13</div>
                </div>
              </div>
              <div class="text_list">
                <div class="item_list">
                  <span>孩子为什么不吃饭？</span>
                  <div>2013-03-13</div>
                </div>
              </div>
            </div>
          </div>
          <!--右-->
          <div class="disease_card_right">
            <div class="item_list">
              <div class="GraphicText_list">
                <div class="item_GraphicText_list">
                  <div class="GraphicImg">
                    <img src="../assets/images/home/jibing3.jpeg" alt="">
                  </div>
                  <div class="textTime">
                    <div>没有心脏病的人也会出现心源性猝死吗，这是为什么呢？没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗</div>
                    <span>2020-03-12</span>
                  </div>
                </div>
              </div>
              <div class="hot_list">
                <div class="item_hot_list">
                  <div class="joint_box">
                    <img src="../assets/images/home/left_img.png" alt="">
                  </div>
                  <div class="hot_text">冠心病的早期症状有哪些？怎么预防</div>
                </div>
              </div>
            </div>
            <div class="item_list">
              <div class="GraphicText_list">
                <div class="item_GraphicText_list">
                  <div class="GraphicImg">
                    <img src="../assets/images/home/jibing3.jpeg" alt="">
                  </div>
                  <div class="textTime">
                    <div>没有心脏病的人也会出现心源性猝死吗，这是为什么呢？没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗</div>
                    <span>2020-03-12</span>
                  </div>
                </div>
              </div>
              <div class="hot_list">
                <div class="item_hot_list">
                  <div class="joint_box">
                    <img src="../assets/images/home/left_img.png" alt="">
                  </div>
                  <div class="hot_text">冠心病的早期症状有哪些？怎么预防</div>
                </div>
              </div>
            </div>
            <div class="item_list">
              <div class="GraphicText_list">
                <div class="item_GraphicText_list">
                  <div class="GraphicImg">
                    <img src="../assets/images/home/jibing3.jpeg" alt="">
                  </div>
                  <div class="textTime">
                    <div>没有心脏病的人也会出现心源性猝死吗，这是为什么呢？没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗</div>
                    <span>2020-03-12</span>
                  </div>
                </div>
              </div>
              <div class="hot_list">
                <div class="item_hot_list">
                  <div class="joint_box">
                    <img src="../assets/images/home/left_img.png" alt="">
                  </div>
                  <div class="hot_text">冠心病的早期症状有哪些？怎么预防</div>
                </div>
              </div>
            </div>
            <div class="item_list">
              <div class="GraphicText_list">
                <div class="item_GraphicText_list">
                  <div class="GraphicImg">
                    <img src="../assets/images/home/jibing3.jpeg" alt="">
                  </div>
                  <div class="textTime">
                    <div>没有心脏病的人也会出现心源性猝死吗，这是为什么呢？没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗</div>
                    <span>2020-03-12</span>
                  </div>
                </div>
              </div>
              <div class="hot_list">
                <div class="item_hot_list">
                  <div class="joint_box">
                    <img src="../assets/images/home/left_img.png" alt="">
                  </div>
                  <div class="hot_text">冠心病的早期症状有哪些？怎么预防</div>
                </div>
              </div>
            </div>
            <div class="item_list">
              <div class="GraphicText_list">
                <div class="item_GraphicText_list">
                  <div class="GraphicImg">
                    <img src="../assets/images/home/jibing3.jpeg" alt="">
                  </div>
                  <div class="textTime">
                    <div>没有心脏病的人也会出现心源性猝死吗，这是为什么呢？没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗</div>
                    <span>2020-03-12</span>
                  </div>
                </div>
              </div>
              <div class="hot_list">
                <div class="item_hot_list">
                  <div class="joint_box">
                    <img src="../assets/images/home/left_img.png" alt="">
                  </div>
                  <div class="hot_text">冠心病的早期症状有哪些？怎么预防</div>
                </div>
              </div>
            </div>
            <div class="item_list">
              <div class="GraphicText_list">
                <div class="item_GraphicText_list">
                  <div class="GraphicImg">
                    <img src="../assets/images/home/jibing3.jpeg" alt="">
                  </div>
                  <div class="textTime">
                    <div>没有心脏病的人也会出现心源性猝死吗，这是为什么呢？没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗没有心脏病的人也会出现心源性猝死吗</div>
                    <span>2020-03-12</span>
                  </div>
                </div>
              </div>
              <div class="hot_list">
                <div class="item_hot_list">
                  <div class="joint_box">
                    <img src="../assets/images/home/left_img.png" alt="">
                  </div>
                  <div class="hot_text">冠心病的早期症状有哪些？怎么预防</div>
                </div>
              </div>
            </div>
            <!--查看更多-->
            <div class="handle_more">查看更多>>>></div>
          </div>
        </div>
      </div>
      <!--科普视频-->
      <div class="home_KpVideo">
        <!--头部-->
        <div class="home_KpVideo_header">
          <div class="KpVideo_header_text">
            <span>科普</span>
            <div></div>
            <span>视频</span>
          </div>
          <div class="english_name">
            <div></div>
            <span>POPULAR  SCIENCE  VIDEO</span>
            <div></div>
          </div>
        </div>
        <!--导航-->
        <div  class="home_KpVideo_nav">
          <ul v-if="0" class="KpVideo_navList">
            <li @click="handleClickTap(1)">最新</li>
            <li @click="handleClickTap(2)">最热</li>
            <li @click="handleClickTap(3)">特邀</li>
            <li @click="handleClickTap(4)">疾病</li>
            <li @click="handleClickTap(5)">健康</li>
          </ul>
          <div class="nav_title">热门视频</div>
          <div class="KpVideo_rightBut">
            <div @click="$router.push(type=='tt'?'/tt/kpVideo'+'.html':'/kpVideo')">更多>></div>
          </div>
        </div>
        <!--card区-->
        <div class="home_KpVideo_Card">
          <div class="KpVideo_Card_list">
            <div class="item_Card_list" v-for="item in videoData" :key="item.id" @click="handleVideoClick(item.id)">
              <div class="card_img">
                <img :src="item.coverUrl" alt="">
                <div>{{item.title}}</div>
              </div>
              <div class="card_name">
                <div>{{item.doctorName}}</div>
                <span>{{item.hospitalName}}{{item.doctorLevelName}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--科普语音-->
      <div class="home_KpVoice">
        <!--头部-->
        <div class="home_KPVoice_header">
          <div class="KPVoice_header_text">
            <span>科普</span>
            <div></div>
            <span>语音</span>
          </div>
          <div class="english_name">
            <div></div>
            <span>POPULAR  SCIENCE  PRONUNCIATION</span>
            <div></div>
          </div>
        </div>
        <!--导航-->
        <div class="home_KPVoice_nav" v-if="0">
          <ul class="KPVoice_navList">
            <li>最新</li>
            <li>内科</li>
            <li>外科</li>
            <li>妇产科</li>
            <li>儿科</li>
          </ul>
          <div class="nav_title">热门语音</div>
          <div class="KPVoice_rightBut">
            <div >更多>></div>
          </div>
        </div>
        <!--card-->
        <div class="KPVoice_card">
          <!--左-->
          <div class="KPVoice_card_left" v-if="oneAudioData">
            <div class="KPVoice_warpTop">
              <img style="cursor: pointer;" @click="handleAudioClick(oneAudioData.id)" class="KPVoice_img" :src="oneAudioData.coverUrl" alt="">
              <div class="voice_title_box">
                <div class="title_box_top" @click="handleAudioClick(oneAudioData.id)">{{oneAudioData.title}}</div>
                <div class="title_box_con">
                  <img :src="oneAudioData.coverUrl" alt="">
                  <div class="doctor_headName">
                    <div class="doctor_box">
                      <div class="doctor_name">
                        <span>{{oneAudioData.doctorName}}</span>
                        <div>{{oneAudioData.doctorLevelName}}</div>
                      </div>
                      <div class="hospital_name">
                        <span>{{oneAudioData.hospitalName}}</span>
                        <div>{{oneAudioData.departmentName}}</div>
                      </div>
                    </div>
                    <div class="doctor_audio">
                      <Audio :styles="{width:'249px', height:'35px'}" :url="'http://image.cicheng120.com/voice-1183547-1622066-12589-高度近视到多少度就看不见了-赵阳-20200424151920.mp3'"/>
                    </div>
                  </div>
                </div>
                <div class="title_box_bottom">肝炎流行季节或流行地区以及家中有急性肝炎患者时应高度警惕、时时提防。少数人在发病前曾有过类似“感冒”的症状…………</div>
              </div>
            </div>
            <div class="KPVoice_warpBottom">
              <div class="warpBottom_doctor_card" @click="handleAudioClick(item.id)" v-for="item in twoAudioData" :key="item.id">
                <div class="item_doctor_card">
                  <div class="item_UserInfo">
                    <div class="title_box_con">
                      <img :src="item.coverUrl" alt="">
                      <div class="doctor_headName">
                        <div class="doctor_box">
                          <div class="doctor_name">
                            <span>{{item.doctorName}}</span>
                            <div>{{item.doctorLevelName}}</div>
                          </div>
                        </div>
                        <div class="goodAt">擅长：{{item.doctorSkill}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="item_userList">
                    <div class="question_list">
                      <div>{{item.title}}</div>
                      <img src="../assets/images/home/shengyin.png" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--右-->
          <div class="KPVoice_card_right">
            <div class="item_voiceList" @click="handleAudioClick(item.id)" v-for="item in threeAudioData" :key="item.id">
              <div class="GraphicText_list">
                <div class="item_GraphicText_list">
                  <div class="GraphicImg">
                    <img :src="item.coverUrl" alt="">
                  </div>
                  <div class="textTime">
                    <div class="text_jieshao">{{item.title}}</div>
                    <div class="text_bottom">
                      <div class="name">
                        <div>{{item.doctorName}}</div>
                        <span class="title">{{item.doctorLevelName}}</span>
                      </div>
                      <img src="../assets/images/home/shengyin.png" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--热门-->
            <div class="item_voiceList" @click="handleAudioClick(item.id)" v-for="item in HotaudioData" :key="item.id">
              <div class="hot_list">
                <div class="item_hot_list">
                  <div class="joint_box">
                    <img src="../assets/images/home/left_img.png" alt="">
                  </div>
                  <div class="hot_text">{{item.title}}</div>
                  <img src="../assets/images/home/shengyin.png" alt="">
                </div>
              </div>
            </div>
            <!--查看更多-->
            <div class="handle_more" @click="$router.push(type=='tt'?'/tt/kpVoice'+'.html':'/kpVoice')">查看更多>>>></div>
          </div>
        </div>
      </div>
      <!--科普文章-->
      <div v-if="0" class="home_KpArticle">
        <!--头部-->
        <div class="home_KpArticle_header">
          <div class="KpArticle_header_text">
            <span>科普</span>
            <div></div>
            <span>文章</span>
          </div>
          <div class="english_name">
            <div></div>
            <span>POPULAR  SCIENCE  ARTICLE</span>
            <div></div>
          </div>
        </div>
        <!--card区-->
        <div class="KpArticle_card">
          <!--左-->
          <div class="KpArticle_card_left">
            <div class="card_left_imgBox">
              <img src="../assets/images/home/ceshi1.jpeg" alt="">
              <div class="card_left_maskBox">高血压患者日常饮食注意事项</div>
            </div>
            <div class="card_left_imgBox">
              <img src="../assets/images/home/ceshi1.jpeg" alt="">
              <div class="card_left_maskBox">高血压患者日常饮食注意事项</div>
            </div>
          </div>
          <!--中-->
          <div class="KpArticle_card_centre">
            <div class="card_centre_matter">
              <div class="centre_matter_title">
                <div>年轻人高血压一般是什么原因</div>
                <span>2020-02-22</span>
              </div>
              <div class="centre_matter_list">
                <div class="matterList_item">
                  <img src="../assets/images/home/u465.png" alt="">
                  <div>雾霾对呼吸道的危害有多大</div>
                </div>
                <div class="matterList_item">
                  <img src="../assets/images/home/u465.png" alt="">
                  <div>雾霾对呼吸道的危害有多大</div>
                </div>
                <div class="matterList_item">
                  <img src="../assets/images/home/u465.png" alt="">
                  <div>雾霾对呼吸道的危害有多大</div>
                </div>
                <div class="matterList_item">
                  <img src="../assets/images/home/u465.png" alt="">
                  <div>雾霾对呼吸道的危害有多大</div>
                </div>
                <div class="matterList_item">
                  <img src="../assets/images/home/u465.png" alt="">
                  <div>雾霾对呼吸道的危害有多大</div>
                </div>
                <div class="matterList_item">
                  <img src="../assets/images/home/u465.png" alt="">
                  <div>雾霾对呼吸道的危害有多大</div>
                </div>
                <div class="matterList_item">
                  <img src="../assets/images/home/u465.png" alt="">
                  <div>雾霾对呼吸道的危害有多大</div>
                </div>
                <div class="matterList_item">
                  <img src="../assets/images/home/u465.png" alt="">
                  <div>雾霾对呼吸道的危害有多大</div>
                </div>
              </div>
            </div>
            <div class="card_centre_matter">
              <div class="centre_matter_title">
                <div>年轻人高血压一般是什么原因</div>
                <span>2020-02-22</span>
              </div>
              <div class="centre_matter_list">
                <div class="matterList_item">
                  <img src="../assets/images/home/u465.png" alt="">
                  <div>雾霾对呼吸道的危害有多大</div>
                </div>
                <div class="matterList_item">
                  <img src="../assets/images/home/u465.png" alt="">
                  <div>雾霾对呼吸道的危害有多大</div>
                </div>
                <div class="matterList_item">
                  <img src="../assets/images/home/u465.png" alt="">
                  <div>雾霾对呼吸道的危害有多大</div>
                </div>
                <div class="matterList_item">
                  <img src="../assets/images/home/u465.png" alt="">
                  <div>雾霾对呼吸道的危害有多大</div>
                </div>
                <div class="matterList_item">
                  <img src="../assets/images/home/u465.png" alt="">
                  <div>雾霾对呼吸道的危害有多大</div>
                </div>
                <div class="matterList_item">
                  <img src="../assets/images/home/u465.png" alt="">
                  <div>雾霾对呼吸道的危害有多大</div>
                </div>
                <div class="matterList_item">
                  <img src="../assets/images/home/u465.png" alt="">
                  <div>雾霾对呼吸道的危害有多大</div>
                </div>
                <div class="matterList_item">
                  <img src="../assets/images/home/u465.png" alt="">
                  <div>雾霾对呼吸道的危害有多大</div>
                </div>
              </div>
            </div>
          </div>
          <!--右-->
          <div class="KpArticle_card_right">
            <div class="yiQiKan">
              <span>大家都在看</span>
              <div>更多>></div>
            </div>
            <div class="card_right_list">
              <div class="right_list_item">
                <div class="item_num">2</div>
                <div class="item_title">怎样预防泌尿系统结石？</div>
                <div class="item_oneCard">
                  <div class="oneCard_left">
                    <img src="../assets/images/home/ceshi1.jpeg" alt="">
                    <div>1</div>
                  </div>
                  <div class="oneCard_right">
                    <div class="header">糖尿病病因有哪些</div>
                    <div class="title">
                      <div>张三三</div>
                      <span>副主任医师  </span>
                    </div>
                    <div class="time">2020-03-12</div>
                  </div>
                </div>
              </div>
              <div class="right_list_item">
                <div class="item_num">2</div>
                <div class="item_title">怎样预防泌尿系统结石？</div>
                <div class="item_oneCard">
                  <div class="oneCard_left">
                    <img src="../assets/images/home/ceshi1.jpeg" alt="">
                    <div>1</div>
                  </div>
                  <div class="oneCard_right">
                    <div class="header">糖尿病病因有哪些</div>
                    <div class="title">
                      <div>张三三</div>
                      <span>副主任医师  </span>
                    </div>
                    <div class="time">2020-03-12</div>
                  </div>
                </div>
              </div>
              <div class="right_list_item">
                <div class="item_num">2</div>
                <div class="item_title">怎样预防泌尿系统结石？</div>
                <div class="item_oneCard">
                  <div class="oneCard_left">
                    <img src="../assets/images/home/ceshi1.jpeg" alt="">
                    <div>1</div>
                  </div>
                  <div class="oneCard_right">
                    <div class="header">糖尿病病因有哪些</div>
                    <div class="title">
                      <div>张三三</div>
                      <span>副主任医师  </span>
                    </div>
                    <div class="time">2020-03-12</div>
                  </div>
                </div>
              </div>
              <div class="right_list_item">
                <div class="item_num">2</div>
                <div class="item_title">怎样预防泌尿系统结石？</div>
                <div class="item_oneCard">
                  <div class="oneCard_left">
                    <img src="../assets/images/home/ceshi1.jpeg" alt="">
                    <div>1</div>
                  </div>
                  <div class="oneCard_right">
                    <div class="header">糖尿病病因有哪些</div>
                    <div class="title">
                      <div>张三三</div>
                      <span>副主任医师  </span>
                    </div>
                    <div class="time">2020-03-12</div>
                  </div>
                </div>
              </div>
              <div class="right_list_item">
                <div class="item_num">2</div>
                <div class="item_title">怎样预防泌尿系统结石？</div>
                <div class="item_oneCard">
                  <div class="oneCard_left">
                    <img src="../assets/images/home/ceshi1.jpeg" alt="">
                    <div>1</div>
                  </div>
                  <div class="oneCard_right">
                    <div class="header">糖尿病病因有哪些</div>
                    <div class="title">
                      <div>张三三</div>
                      <span>副主任医师  </span>
                    </div>
                    <div class="time">2020-03-12</div>
                  </div>
                </div>
              </div>
              <div class="right_list_item">
                <div class="item_num">2</div>
                <div class="item_title">怎样预防泌尿系统结石？</div>
                <div class="item_oneCard">
                  <div class="oneCard_left">
                    <img src="../assets/images/home/ceshi1.jpeg" alt="">
                    <div>1</div>
                  </div>
                  <div class="oneCard_right">
                    <div class="header">糖尿病病因有哪些</div>
                    <div class="title">
                      <div>张三三</div>
                      <span>副主任医师  </span>
                    </div>
                    <div class="time">2020-03-12</div>
                  </div>
                </div>
              </div>
              <div class="right_list_item">
                <div class="item_num">2</div>
                <div class="item_title">怎样预防泌尿系统结石？</div>
                <div class="item_oneCard">
                  <div class="oneCard_left">
                    <img src="../assets/images/home/ceshi1.jpeg" alt="">
                    <div>1</div>
                  </div>
                  <div class="oneCard_right">
                    <div class="header">糖尿病病因有哪些</div>
                    <div class="title">
                      <div>张三三</div>
                      <span>副主任医师  </span>
                    </div>
                    <div class="time">2020-03-12</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--三甲名医-->
      <div class="home_fameDoctor">
        <!--头部-->
        <div class="home_fameDoctor_header">
          <div class="fameDoctor_header_text">
            <span>三甲</span>
            <div></div>
            <span>名医</span>
          </div>
          <div class="english_name">
            <div></div>
            <span>TOP  THREE DOCTORS</span>
            <div></div>
          </div>
        </div>
        <!--轮播-->
        <div class="fameDoctor_swiper">
          <div id="fameDoctor_swiper" class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item_s,index) in num" :key="index">
                <div class="swiper_listBox" @click="handleDoctorShow(item.doctorId)" v-for="(item,indexs) in doctorData " :key="item.doctorId"  v-if="indexs>=index*5 && indexs <(index+1)*5">
                  <!--上-->
                  <div class="slide_top">
                    <img :src="item.headImage" alt="">
                  </div>
                  <!--中-->
                  <div class="slide_center">
                    <div class="user_name">
                      <div>{{item.doctorName}}</div>
                      <span>{{item.doctorLevelName}}</span>
                    </div>
                    <div class="user_title">
                      <div>{{item.hospitalName}}</div>
                      <span>{{item.departmentName}}</span>
                    </div>
                    <div class="user_num">
                      <div class="video_box">
                        <div>视频</div>
                        <span>{{item.videoCount}}</span>
                      </div>
                      <div class="audio_box">
                        <div>语音</div>
                        <span>{{item.voiceCount}}</span>
                      </div>
                      <div class="text_box">
                        <div>问答</div>
                        <span>{{item.askCount}}</span>
                      </div>
                    </div>
                  </div>
                  <!--下-->
                  <div class="slide_bottom">查看</div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination" slot="pagination"></div>
          </div>
        </div>
        <!--底部-->
        <div class="home_fameDoctor_bottom" @click="$router.push(type=='tt'?'/tt/salientDoctor'+'.html':'/salientDoctor')">查看更多医生</div>
      </div>
      <!--互动问答-->
      <div class="home_interact">
        <!--头部-->
        <div class="home_interact_header">
          <div class="interact_header_text">
            <span>互动</span>
            <div></div>
            <span>问答</span>
          </div>
          <div class="english_name">
            <div></div>
            <span>QUESTION  AND  ANSWER</span>
            <div></div>
          </div>
        </div>
        <!--内容card-->
        <div class="home_interact_card">
          <div class="interact_card_left">
            <!---->
            <div v-if="0" class="card_left_list">
              <ul class="KPVoice_navList">
                <li class="active">最新解答</li>
                <li>病因</li>
                <li>症状</li>
                <li>检查</li>
                <li>用药</li>
                <li>治疗</li>
                <li>急救</li>
                <li>护理</li>
                <li>其他</li>
              </ul>
            </div>
            <!---->
            <div class="card_leftList_centre">
              <div class="item_List" @click="handleAnswerShow(item.id)" v-for="item in oneAnswerData" :key="item.id">
                <div class="list_oneBox">
                  <div class="list_top">
                    <img src="../assets/images/home/home_msg.png" alt="">
                    <div>{{item.title}}</div>
                  </div>
                  <div class="list_textBox">{{item.content}}</div>
                </div>
                <div class="list_twoBox">
                  <div class="list_twoBox_Q">
                    <div>Q</div>
                    <span>{{item.title}}</span>
                  </div>
                  <div class="list_twoBox_A">
                    <div>A</div>
                    <span>{{item.content}}</span>
                  </div>
                  <div class="list_twoBox_bottom">
                    <div class="doctor_head">
                      <img :src="item.coverUrl" alt="">
                      <div class="doctor_name">{{item.doctorName}}</div>
                      <div class="doctor_title">{{item.doctorLevelName}}</div>
                      <div class="doctor_hospital">{{item.hospitalName}}</div>
                      <div class="doctor_twoTitle">{{item.departmentName}}</div>
                    </div>
                    <!--<div class="doctor_add">查看他的更多问答</div>-->
                  </div>
                </div>
              </div>
            </div>
            <!---->
            <div class="card_leftList_bottom">
              <div class="item_list" @click="handleAnswerShow(item.id)" v-for="item in twoAnswerData" :key="item.id">
                <div class="left_title">
                  <img src="../assets/images/home/u844.png" alt="">
                  <div>{{item.title}}</div>
                </div>
                <div class="right_time">{{item.publishTime}}</div>
              </div>
            </div>
          </div>
          <div class="interact_card_right">
            <div class="yiQiKan">
              <span>大家都在看</span>
              <div @click="$router.push(type=='tt'?'/tt/answerList'+'.html':'/answerList')">更多>></div>
            </div>
            <div class="card_right_list">
              <div class="right_list_item" @click="handleAnswerShow(item.id)" v-for="(item,index) in threeAnswerData" :key="item.id">
                <div class="item_num">{{index+1}}</div>
                <div class="item_title">{{item.title}}</div>
                <div class="item_oneCard">
                  <div class="oneCard_left">
                    <img :src="item.coverUrl" alt="">
                    <div>{{index+1}}</div>
                  </div>
                  <div class="oneCard_right">
                    <div class="header">{{item.title}}</div>
                    <div class="title">
                      <div>{{item.doctorName}}</div>
                      <span>{{item.doctorLevelName}}</span>
                    </div>
                    <div class="time">{{item.publishTime}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import Audio from '../components/audio/Index'
  import Swiper from 'swiper'
  export default {
    name: "Home",
    components:{
      Audio
    },
    data() {
      return {
        videoData:[],
        audioData:[],
        HotaudioData:[],
        doctorData:[],
        AnswerData:[],
        swiperData:[],
        num:null,
        type:''
      }
    },
    created(){
      this.type=this.$route.path.split('/')[1]
      console.log(this.type)
    },
    methods:{
      // 点击视频
      handleVideoClick(id) {
        this.$router.push({path:'/kpVideo/kpVideoShow/'+id})
      },
      // 点击音频
      handleAudioClick(id) {
        this.$router.push({path:'/kpVoice/kpVoiceShow/'+id,query:{}})
      },
      // 点击医生
      handleDoctorShow(id) {
        this.$router.push({path:'/salientDoctor/salientDoctorShow/'+id,query:{}})
      },
      // 点击问答
      handleAnswerShow(id) {
        this.$router.push({path:'/answerList/answeShow/'+id,query:{}})
      },
      // --------------------------- 初始化 ---------------------------
      // 初始化头部轮播
      _initSwiper() {
        let mySwiper = new Swiper('#bigOne_swiper', {
          autoplay: {
            delay: 3000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
          },
          loop : true,
          pagination: {
            el: '.swiper-pagination',
            clickable :true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          //用户操作后, autoplay会默认停止, 这个是取消禁止autoplay
          autoplayDisableOnInteraction: false,
        })
      },
      // 初始化三甲医生轮播
      _initFameDoctorSwiper() {
        let mySwiper = new Swiper('#fameDoctor_swiper', {
          autoplay: {
            delay: 5000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
          },
          loop : true,
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swiper
          //用户操作后, autoplay会默认停止, 这个是取消禁止autoplay
          autoplayDisableOnInteraction: false,
          pagination: {
            el: '.swiper-pagination',
            clickable :true,
          },
        })
      },
      // 获取视频列表
      getVideoList() {
        const data = {
          // page:1,
          // size:10,
        }
        this.$api.mykp_home.findallVideoTree() .then(res => {
          if(res.code == '000000'){
            this.videoData = res.infos.video
            this.audioData = res.infos.voice
            this.HotaudioData = res.infos.hotVoice
            this.AnswerData = res.infos.artice
          }
        })
      },
      // 获取语音列表
      // getAudioList() {
      //   const data = {
      //     type:2,
      //     page:1,
      //     size:10,
      //     hot:false
      //   }
      //   this.$api.mykp_home.findVideoTree(data) .then(res => {
      //     if(res.code == '000000'){
      //       this.audioData = res.infos.list
      //     }
      //   })
      // },
      // 获取热门语音列表
      // getHotAudioList() {
      //   const data = {
      //     type:2,
      //     page:1,
      //     size:3,
      //     hot:true
      //   }
      //   this.$api.mykp_home.findVideoTree(data) .then(res => {
      //     if(res.code == '000000'){
      //       this.HotaudioData = res.infos.list
      //     }
      //   })
      // },
      // 获取医生列表
      getDoctorList() {
        let params = {
          page:1,
          size:10,
        }
        this.$api.mykp_home.findDoctorTree(params) .then(res => {
          if(res.code == '000000') {
            this.doctorData = res.infos.list
            this.num = Math.ceil(this.doctorData.length/5)
            this.$nextTick(() => {
              this._initFameDoctorSwiper()
            })
          }
        })
      },
      // 获取问答列表
      // getAnswerList() {
      //   const data = {
      //     type:1,
      //     page:1,
      //     size:20,
      //     hot:false
      //   }
      //   this.$api.mykp_home.findVideoTree(data) .then(res => {
      //     if(res.code == '000000'){
      //       this.AnswerData = res.infos.list
      //     }
      //   })
      // },
      // 获取轮播数据
      getSwiperDara() {
        let params = {
          type:0
        }
        this.$api.mykp_home.findSwiperTree(params) .then(res => {
          if(res.code == '000000') {
            this.swiperData = res.infos
            this.$nextTick(() => {
              this._initSwiper()
            })
          }
        })
      },
    },
    computed:{
      oneAudioData:function(){
        return this.audioData[0]
      },
      twoAudioData:function(){
        return this.audioData.slice(1,4)
      },
      threeAudioData:function(){
        return this.audioData.slice(4,7)
      },
      oneAnswerData:function () {
        return this.AnswerData.slice(0,3)
      },
      twoAnswerData:function () {
        return this.AnswerData.slice(3,9)
      },
      threeAnswerData:function () {
        return this.AnswerData.slice(9,20)
      },
    },
    activated() {
      this.getSwiperDara()

      this.getVideoList()
      // this.getAudioList()
      // this.getHotAudioList()
      this.getDoctorList()
      // this.getAnswerList()
    },
  }
</script>
<style lang="stylus" >
  div{
    box-sizing border-box
  }
  input{
    border:none
    &:focus {
      outline: none;
      background:none;
      border:0
    }
  }
  // 梦开始的地方
  .home_area{
    width 100%
    height 100%
    // 轮播区
    .home_swiper{
      width 1200px
      margin 0 auto
      // 轮播
      .swiper-container {
        margin-top 20px
        width:100%
        height 600px
        .swiper-slide{
          cursor: pointer
        }
        img{
          width 100%
          height 100%
        }
      }
    }
    // 内容区
    .home_content{
      width 1200px
      margin 0 auto
      // 疾病百科
      .home_disease{
        padding-top 80px
        .home_disease_header{
          .disease_header_text{
            display flex
            align-items center
            justify-content center
            >span{
              font-size 36px
              color #000
              font-weight 700
            }
            >div{
              width: 20px
              height: 20px
              border 1px solid #5bb7e2
              transform rotate(45deg)
              margin  0 20px
            }
          }
          .english_name{
            margin-top 20px
            display flex
            align-items center
            justify-content space-between
            >div{
                height: 1px
                background #dcdcdc
                flex 1
              }
            >span{
              font-size 20px
              color: #BCBCBC
              font-weight 700
              margin 0 20px
            }
          }
        }
        .home_disease_nav{
          margin-top 40px
          display flex
          justify-content space-between
          align-items center
          .disease_navList{
            display flex
            >li{
              cursor: pointer
              padding 11px 14px
              box-sizing border-box
              color: #4f4f4f
              border 1px solid #797979
              border-radius 4px
              margin-right 15px
              &:hover{
                border 1px solid #0d83f8
                background #0d83f8
                color: #fff
              }
              &.active{
                border 1px solid #0d83f8
                background #0d83f8
                color: #fff
              }
            }
          }
          .disease_rightBut{
            cursor: pointer
            display flex
            align-items center
            justify-content center
            width: 84px
            height: 26px
            border 1px solid #1083F8
            >div{
              color: #1083F8
              font-size 16px
            }
          }
        }
        .disease_card{
          margin-top 30px
          display flex
          justify-content space-between
          .disease_card_left{
            padding-right 2px
            width:395px
            //height 400px
            .card_left_img{
              display flex
              justify-content space-between
              flex-wrap wrap
              .img_list{
                position relative
                margin-bottom 12px
                cursor: pointer
                >img{
                  width: 195px
                  height: 135px
                }
                >div{
                  position absolute
                  left:0
                  bottom:3px
                  width: 195px
                  height: 30px
                  background rgba(0,0,0,0.5)
                  color: #fff
                  font-weight 700
                  line-height 30px
                  /*省略号*/
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  text-align: center
                }
              }
            }
            .card_left_text{
              .text_list{
                cursor: pointer
                height 50px
                background #f2f2f2
                margin-bottom 14px
                padding 0 10px
                &:last-child{
                  margin-bottom 0
                }
                .item_list{
                  height 50px
                  display flex
                  align-items center
                  justify-content space-between
                  >span{
                    width 70%
                    color: #5E5E5E
                    font-size:14px
                    font-weight 700
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                  >div{
                    color: #868686
                    font-size 12px
                  }
                }
              }
            }
          }
          .disease_card_center{
            width:395px
            height 400px
            padding 0 2px
            .card_center_question{
              .item_question{
                >div{
                  font-weight: 700;
                  font-size: 16px;
                  margin-bottom 12px
                  color: #333
                  cursor: pointer
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                >span{
                  font-size: 14px;
                  line-height: 22px;
                  color: #333
                  text-overflow: -o-ellipsis-lastline;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 3;
                  -webkit-box-orient: vertical;
                }
              }
            }
            .card_hot_topic{
              margin-top 20px
              .hot_topic_list{
                padding 14px 10px
                border-top 1px dashed #eee
                cursor: pointer
                .item_topic_list{
                  width 100%
                  display flex
                  justify-content space-between
                  align-items center
                  .hot_topic_text{
                    display flex
                    align-items center
                    .mask_box{
                      width: 10px;
                      height: 10px;
                      border-radius 50%
                      background #bcbcbc
                      margin-right 8px
                    }
                    .Topic_text{
                      color: #5E5E5E
                      font-size 14px
                      font-weight:700
                      width 250px
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    }
                  }
                  .hot_topic_time{
                    color: #868686
                    font-size 12px
                  }
                }
                .hot_topic_text{
                  display flex
                  align-items center
                  .mask_box{
                    width: 10px;
                    height: 10px;
                    border-radius 50%
                    background #bcbcbc
                    margin-right 8px
                  }
                  .Topic_text{
                    color: #5E5E5E
                    font-size 14px
                    font-weight:700
                    width 250px
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                }
                .hot_topic_time{
                  color: #868686
                  font-size 12px
                }
              }
            }
            .card_center_text{
              margin-top 14px
              .text_list{
                cursor: pointer
                height 50px
                background #f2f2f2
                margin-bottom 14px
                padding 0 10px
                &:last-child{
                  margin-bottom 0
                }
                .item_list{
                  height 50px
                  display flex
                  align-items center
                  justify-content space-between
                  >span{
                    width 70%
                    color: #5E5E5E
                    font-size:14px
                    font-weight 700
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                  >div{
                    color: #868686
                    font-size 12px
                  }
                }
              }
            }
          }
          .disease_card_right{
            width:395px
            padding-left 2px
            .item_list{
              cursor: pointer
              &:nth-child(-n+3){
                .GraphicText_list{
                  display flex
                }
                .hot_list{
                  display  none
                }
              }
              .GraphicText_list{
                margin-bottom 16px
                display none
                flex 1
                .item_GraphicText_list{
                  display flex
                  .GraphicImg{
                    >img{
                      width: 101px
                      height: 70px
                      margin-right 15px
                    }
                  }
                  .textTime{
                    height: 70px
                    display flex
                    flex-direction column
                    justify-content space-around
                    >div{
                      color: #5E5E5E
                      font-size 14px
                      text-overflow: -o-ellipsis-lastline;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      display: -webkit-box;
                      -webkit-line-clamp: 2;
                      -webkit-box-orient: vertical;
                      line-height 18px
                    }
                    >span{
                      color: #868686
                      font-size 12px
                    }
                  }
                }
              }
              .hot_list{
                margin-bottom 17.3px
                .item_hot_list{
                  display flex
                  align-items center
                  .joint_box{
                    >img{
                      vertical-align middle
                    }
                  }
                  .hot_text{
                    font-size: 14px;
                    color: #5E5E5E;
                    margin-left 12px
                    width: 100%
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                }
              }
            }
            .handle_more{
              cursor: pointer
              width: 100%
              height:34px
              background #f2f2f2
              display flex
              align-items center
              justify-content center
              color: #1083F8
            }
          }
        }
      }
      // 科普视频
      .home_KpVideo {
        padding-top 80px
        .home_KpVideo_header{
          .KpVideo_header_text{
            display flex
            align-items center
            justify-content center
            >span{
              font-size 36px
              color #000
              font-weight 700
            }
            >div{
              width: 20px
              height: 20px
              border 1px solid #5bb7e2
              transform rotate(45deg)
              margin  0 20px
            }
          }
          .english_name{
            margin-top 20px
            display flex
            align-items center
            justify-content space-between
            >div{
                height: 1px
                background #dcdcdc
                flex 1
              }
            >span{
              font-size 20px
              color: #BCBCBC
              font-weight 700
              margin 0 20px
            }
          }
        }
        .home_KpVideo_nav{
          margin-top 40px
          display flex
          justify-content space-between
          align-items center
          .KpVideo_navList{
            display flex
            >li{
              cursor: pointer
              padding 11px 14px
              box-sizing border-box
              color: #4f4f4f
              border 1px solid #797979
              border-radius 4px
              margin-right 15px
              &:hover{
                border 1px solid #0d83f8
                background #0d83f8
                color: #fff
              }
              &.active{
                border 1px solid #0d83f8
                background #0d83f8
                color: #fff
              }
            }
          }
          .KpVideo_rightBut{
            cursor: pointer
            display flex
            align-items center
            justify-content center
            width: 84px
            height: 26px
            border 1px solid #1083F8
            >div{
              color: #1083F8
              font-size 16px
            }
          }
        }
        .home_KpVideo_Card{
          margin-top 40px
          .KpVideo_Card_list{
            display flex
            flex-wrap wrap
            .item_Card_list{
              width: 224px;
              height: 225px;
              display flex
              flex-direction column
              justify-content space-between
              padding-bottom 20px
              margin-bottom 30px
              margin-right 20px
              cursor: pointer
              &:nth-child(5n){
                margin-right 0px
              }
              &:hover{
                box-shadow:0 2px 6px 1px #eee;
              }
              .card_img{
                display flex
                flex-direction column
                >img{
                  width: 224px
                  height: 120px
                }
                >div{
                  margin-top 15px
                  padding 0 15px
                  font-size: 16px;
                  color: #5E5E5E;
                  text-overflow: -o-ellipsis-lastline;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  line-height 20px
                }
                &:after{
                  content ''
                  width 100%
                  height 1px
                  border-top:1px dashed  #eee
                  margin-top 5px
                }
              }

              .card_name{
                padding 0 15px
                display flex
                justify-content space-between
                align-items center
                >div{
                  width 30%
                  font-weight: 700;
                  font-style: normal;
                  font-size: 14px;
                  color: #5E5E5E;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                >span{
                  display block
                  font-size: 12px;
                  color: #5E5E5E;
                  width 70%
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  text-align: right
                }
              }
            }
          }
        }
      }
      // 科普语音
      .home_KpVoice{
        padding-top 80px
        .home_KPVoice_header{
          .KPVoice_header_text{
            display flex
            align-items center
            justify-content center
            >span{
              font-size 36px
              color #000
              font-weight 700
            }
            >div{
              width: 20px
              height: 20px
              border 1px solid #5bb7e2
              transform rotate(45deg)
              margin  0 20px
            }
          }
          .english_name{
            margin-top 20px
            display flex
            align-items center
            justify-content space-between
            >div{
              height: 1px
              background #dcdcdc
              flex 1
            }
            >span{
              font-size 20px
              color: #BCBCBC
              font-weight 700
              margin 0 20px
            }
          }
        }
        .home_KPVoice_nav{
          margin-top 40px
          display flex
          justify-content space-between
          align-items center
          .KPVoice_navList{
            display flex
            >li{
              cursor: pointer
              padding 11px 14px
              box-sizing border-box
              color: #4f4f4f
              border 1px solid #797979
              border-radius 4px
              margin-right 15px
              &:hover{
                border 1px solid #0d83f8
                background #0d83f8
                color: #fff
              }
              &.active{
                border 1px solid #0d83f8
                background #0d83f8
                color: #fff
              }
            }
          }
          .KPVoice_rightBut{
            cursor: pointer
            display flex
            align-items center
            justify-content center
            width: 84px
            height: 26px
            border 1px solid #1083F8
            >div{
              color: #1083F8
              font-size 16px
            }
          }
        }
        .KPVoice_card{
          margin-top 30px
          display flex
          justify-content space-between
          .KPVoice_card_left{
            padding-right 2px
            width:790px
            .KPVoice_warpTop{
              display flex
              justify-content space-between
              .KPVoice_img{
                width: 260px;
                height: 203px;
                margin-right 20px
              }
              .voice_title_box{
                display flex
                flex-direction column
                justify-content space-between
                flex 1
                .title_box_top{
                  width: 508px
                  font-weight: 700;
                  font-style: normal;
                  font-size: 20px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  cursor: pointer
                }
                .title_box_con{
                  display flex
                  align-items center
                  >img{
                    width: 80px;
                    height: 80px;
                    border-radius 50%
                    margin-right 10px
                  }
                  .doctor_headName{
                    height: 80px;
                    display flex
                    flex-direction column
                    justify-content space-around
                    .doctor_box{
                      display flex
                      justify-content space-between
                      width 420px
                      .doctor_name{
                        display flex
                        align-items center
                        width 40%
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        margin-right 10px
                        >span{
                          width: 40%
                          display block
                          font-weight: 700;
                          font-size: 18px;
                          color: #000000;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                        }
                        >div{
                          width: 60%
                          font-size: 18px;
                          color: #000000;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                        }
                      }
                      .hospital_name{
                        display flex
                        align-items center
                        width: 60%
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        >span{
                          display block
                          font-size: 16px;
                          color: #000000;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                        }
                        >div{
                          font-size: 16px;
                          color: #000000;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                        }
                      }
                    }
                    .doctor_audio{
                      >audio{
                        width: 249px;
                        height: 35px;
                        outline none
                      }
                    }
                  }
                }
                .title_box_bottom{
                  font-size: 16px;
                  line-height: 24px;
                  color: #333
                  text-overflow: -o-ellipsis-lastline;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                }
              }
            }
            .KPVoice_warpBottom{
              margin-top 20px
              display flex
              justify-content space-between
              align-items center
              .warpBottom_doctor_card{
                .item_doctor_card{
                  width: 258px;
                  height: 226px;
                  border-radius 7px
                  border 1px solid #8cd4a7
                  padding 20px 5px
                  cursor: pointer
                  .item_UserInfo{
                    &:after{
                      content ''
                      width 100%
                      height:1px
                      display block
                      border-top 1px dashed #eee
                      margin-top 10px
                    }
                    .title_box_con{
                      display flex
                      align-items center
                      justify-content center
                      >img{
                        width: 70px;
                        height: 70px;
                        border-radius 50%
                      }
                      .doctor_headName{
                        width 140px
                        height: 70px;
                        display flex
                        flex-direction column
                        justify-content space-around
                        padding 5px 0
                        margin-left 10px
                        .doctor_box{
                          .doctor_name{
                            display flex
                            align-items center
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            width 140px
                            >span{
                              width: 40%
                              display block
                              font-weight: 700;
                              font-size: 18px;
                              color: #000000;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              white-space: nowrap;
                            }
                            >div{
                              width: 60%
                              font-size: 14px;
                              color: #000000;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              white-space: nowrap;
                              text-align:center
                            }
                          }
                        }
                        .goodAt{
                          font-size: 12px;
                          color: #000
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                        }
                      }
                    }
                  }
                  .item_userList{
                    .question_list{
                      cursor: pointer
                      margin-top 10px
                      padding 0 5px
                      display flex
                      justify-content space-between
                      &:first-child{
                        margin-top 20px
                      }
                      >div{
                        font-size: 16px;
                        color: #333
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                      }
                      >img{
                        width: 20px;
                        height: 20px;
                      }
                    }
                  }
                }
              }
            }
          }
          .KPVoice_card_right{
            margin-top 20px
            width:395px
            .item_voiceList{
              cursor: pointer
              &:nth-child(3) {
                &:after{
                  content: ''
                  display block
                  width 100%
                  height 1px
                  margin 16px 0 16px 0
                  border-top 1px dashed #eee
                }
              }
              .GraphicText_list{
                display flex
                margin-bottom 16px
                flex 1
                .item_GraphicText_list{
                  cursor: pointer
                  display flex
                  .GraphicImg{
                    >img{
                      width: 100px
                      height: 70px
                      margin-right 15px
                    }
                  }
                  .textTime{
                    height: 70px
                    display flex
                    flex-direction column
                    justify-content space-around
                    .text_jieshao{
                      color: #5E5E5E
                      font-size 14px
                      text-overflow: -o-ellipsis-lastline;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      display: -webkit-box;
                      -webkit-line-clamp: 2;
                      -webkit-box-orient: vertical;
                      line-height 18px
                    }
                    .text_bottom{
                      display flex
                      justify-content space-between
                      align-items  center
                      .name{
                        display flex
                        align-items center
                        >div{
                          font-weight: 700;
                          font-size: 18px;
                          color: #000000;
                          margin-right 20px
                          width 60px
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                        }
                        .title{
                          font-size: 14px;
                          color: #000000;
                          width 150px
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                        }
                      }
                      >img{
                        width: 20px
                        height: 20px
                      }
                    }
                  }
                }
              }
              .hot_list{
                margin-bottom 16px
                .item_hot_list{
                  display flex
                  align-items center
                  .joint_box{
                    >img{
                      vertical-align middle
                    }
                  }
                  .hot_text{
                    font-size: 14px;
                    color: #5E5E5E;
                    margin-left 12px
                    width: 100%
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                  >img{
                    width: 20px
                    height: 20px
                  }
                }
              }
            }
            .handle_more{
              cursor: pointer
              width: 100%
              height:34px
              background #f2f2f2
              display flex
              align-items center
              justify-content center
              color: #1083F8
            }
          }
        }
      }

      // 科普文章
      .home_KpArticle{
        padding-top 80px
        .home_KpArticle_header{
          .KpArticle_header_text{
            display flex
            align-items center
            justify-content center
            >span{
              font-size 36px
              color #000
              font-weight 700
            }
            >div{
              width: 20px
              height: 20px
              border 1px solid #5bb7e2
              transform rotate(45deg)
              margin  0 20px
            }
          }
          .english_name{
            margin-top 20px
            display flex
            align-items center
            justify-content space-between
            >div{
              height: 1px
              background #dcdcdc
              flex 1
            }
            >span{
              font-size 20px
              color: #BCBCBC
              font-weight 700
              margin 0 20px
            }
          }
        }
        .KpArticle_card{
          margin-top 40px
          display flex
          justify-content space-between
          .KpArticle_card_left{
            width: 290px
            .card_left_imgBox{
              position relative
              cursor: pointer
              margin-bottom 20px
              >img{
                width: 290px
                height: 200px
              }
              .card_left_maskBox{
                position absolute
                bottom 3px
                left 0
                padding 0 6px
                width: 290px
                height: 37px
                font-size: 16px;
                color: #FFFFFF;
                background rgba(0,0,0,0.6)
                text-align: center
                line-height 37px
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
          .KpArticle_card_centre{
            width: 510px
            .card_centre_matter{
              margin-top 2px
              &:last-child{
                margin-top 33px
              }
              .centre_matter_title{
                display flex
                justify-content space-between
                padding-bottom 10px
                >div{
                  font-weight: 700;
                  font-size: 18px;
                  color: #000000;
                  cursor: pointer
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  width: 80%
                }
                >span{
                  font-size: 14px;
                  color: #C9C9C9;
                }
              }
              .centre_matter_list{
                display flex
                flex-wrap wrap
                justify-content space-between
                align-items center
                .matterList_item{
                  cursor: pointer
                  margin-top 18px
                  display flex
                  justify-content space-between
                  align-items center
                  >img{
                    width: 21px;
                    height: 23px;
                    margin-right 20px
                  }
                  >div{
                    font-size: 16px;
                    color: #333
                    width 200px
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                }
              }
            }
          }
          .KpArticle_card_right{
            width: 361px
            .yiQiKan{
              display flex
              justify-content space-between
              align-items center
              >span{
                font-weight: 700;
                font-size: 18px;
                color: #1083F8;
              }
              >div{
                width: 87px;
                height: 29px;
                border 1px solid #1083f8
                line-height 29px
                text-align: center
                cursor: pointer
                font-size: 18px;
                color: #1083F8
              }
            }
            .card_right_list{
              .right_list_item{
                margin-top 14px
                display flex
                align-items center
                cursor: pointer
                &:first-child{
                  display block
                  padding-bottom  10px
                  .item_num{
                    display none
                  }
                  .item_title{
                    display none
                  }
                  .item_oneCard{
                    display flex
                  }
                  &:after {
                    content ''
                    display flex
                    width: 361px
                    height: 1px
                    border-top 1px dashed #eee
                    margin-top 20px
                    transform translateY(3px)
                  }
                }
                .item_num{
                  width: 35px;
                  height: 29px;
                  text-align: center
                  line-height 29px
                  font-size: 18px;
                  color: #A1A1A1;
                  border 1px solid #e4e4e4
                  margin-right 15px
                }
                .item_title{
                  font-size: 16px;
                  color: #333
                  width 80%
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                .item_oneCard{
                  display none
                  .oneCard_left{
                    position relative
                    >img{
                      width: 148px;
                      height: 83px;
                    }
                    >div{
                      position absolute
                      bottom:3px
                      left: 0
                      width: 35px;
                      height: 29px;
                      text-align: center
                      line-height 29px
                      font-size: 18px;
                      color: #fff;
                      background #ff8a8a
                      margin-right 15px
                    }
                  }
                  .oneCard_right{
                    margin-left 20px
                    width: 185px
                    .header{
                      max-width 200px
                      font-weight: 700;
                      font-size: 18px;
                      color: #333
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    }
                    .title{
                      margin-top 15px
                      max-width 200px
                      display flex
                      >div{
                        font-size: 16px;
                        color: #A1A1A1;
                        max-width: 40%
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        margin-right  10px
                      }
                      >span{
                        font-size: 16px;
                        color: #A1A1A1;
                        max-width: 60%
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                      }
                    }
                    .time{
                      margin-top 15px
                      font-size: 14px;
                      color: #C9C9C9;
                      text-align: right
                    }
                  }
                }
              }
            }
          }
        }
      }
      // 三甲名医
      .home_fameDoctor {
        padding-top 80px
        .home_fameDoctor_header{
          .fameDoctor_header_text{
            display flex
            align-items center
            justify-content center
            >span{
              font-size 36px
              color #000
              font-weight 700
            }
            >div{
              width: 20px
              height: 20px
              border 1px solid #5bb7e2
              transform rotate(45deg)
              margin  0 20px
            }
          }
          .english_name{
            margin-top 20px
            display flex
            align-items center
            justify-content space-between
            >div{
              height: 1px
              background #dcdcdc
              flex 1
            }
            >span{
              font-size 20px
              color: #BCBCBC
              font-weight 700
              margin 0 20px
            }
          }
        }
        .fameDoctor_swiper {
          margin-bottom 30px
          .swiper-container{
            .swiper-wrapper{
              .swiper-slide{
                display flex
                justify-content space-between
                .swiper_listBox{
                  width: 200px
                  height: 450px
                  display flex
                  flex-direction column
                  align-items center
                  justify-content space-around
                  padding-bottom 60px
                  .slide_top{
                    width: 200px
                    height: 200px
                    background #f2f2f2
                    border-radius 50%
                    display flex
                    align-items center
                    justify-content center
                    >img{
                      width: 180px
                      height: 180px
                      border-radius 50%
                    }
                  }
                  .slide_center{
                    display flex
                    flex-direction column
                    align-items center
                    .user_name{
                      /*margin-top 10px*/
                      display flex
                      align-items center
                      >div{
                        font-weight: 700;
                        font-size: 18px;
                        color: #000000;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        width 65px
                        margin-right 10px
                      }
                      >span{
                        font-size: 16px;
                        color #fff
                        width: 85px;
                        height: 31px;
                        background #1083f8
                        display block
                        text-align: center
                        line-height 31px
                        border-radius: 5px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                      }
                    }
                    .user_title{
                      margin-top 20px
                      display flex
                      align-items center
                      >div{
                        width: 100px
                        font-size: 14px;
                        color: #000000;
                        padding-right 10px
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                      }
                      >span{
                        width: 100px
                        display block
                        font-size: 14px;
                        color: #000000;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                      }
                    }
                    .user_num{
                      margin-top 15px
                      width: 200px
                      display flex
                      justify-content space-between
                      .video_box ,.audio_box ,.text_box{
                        display flex
                        align-items center
                        >div{
                          font-size: 14px;
                          color: #000
                        }
                        >span{
                          width 35px
                          color: #8CD4A7;
                          font-size 14px
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                          display block
                          text-align: center
                        }
                      }
                    }
                  }
                  .slide_bottom{
                    width: 68px;
                    height: 25px;
                    border 1px solid #199ed8
                    color: #199ed8
                    border-radius: 5px;
                    text-align: center
                    line-height 25px
                    cursor: pointer
                  }
                }
              }
            }
            .swiper-pagination{
              .swiper-pagination-bullet{
                width: 65px;
                height: 10px;
                border-radius 0
              }
            }
          }
        }
        .home_fameDoctor_bottom{
          width: 183px;
          height: 40px;
          font-size: 18px;
          color: #A1A1A1;
          border 1px solid #d7d7d7
          border-radius 5px
          text-align: center
          line-height:40px
          margin 0 auto
          cursor: pointer
        }
      }
      // 互动问答
      .home_interact{
        padding-top 80px
        .home_interact_header{
          .interact_header_text{
            display flex
            align-items center
            justify-content center
            >span{
              font-size 36px
              color #000
              font-weight 700
            }
            >div{
              width: 20px
              height: 20px
              border 1px solid #5bb7e2
              transform rotate(45deg)
              margin  0 20px
            }
          }
          .english_name{
            margin-top 20px
            display flex
            align-items center
            justify-content space-between
            >div{
              height: 1px
              background #dcdcdc
              flex 1
            }
            >span{
              font-size 20px
              color: #BCBCBC
              font-weight 700
              margin 0 20px
            }
          }
        }
        .home_interact_card{
          display flex
          justify-content space-between
          margin-top 40px
          .interact_card_left{
            width: 819px
            height: 500px
            .card_left_list{
              display flex
              justify-content space-between
              align-items center
              .KPVoice_navList{
                max-width 819px
                display flex
                flex-wrap wrap
                >li{
                  margin-bottom 10px
                  cursor: pointer
                  padding 11px 14px
                  box-sizing border-box
                  color: #4f4f4f
                  border 1px solid #797979
                  border-radius 4px
                  margin-right 15px
                  &:hover{
                    border 1px solid #0d83f8
                    background #0d83f8
                    color: #fff
                  }
                  &.active{
                    border 1px solid #0d83f8
                    background #0d83f8
                    color: #fff
                  }
                }
              }
            }
            .card_leftList_centre{
              margin-top 20px
              .item_List{
                margin-top 15px
                &:after{
                  content ''
                  display block
                  width: 100%
                  height: 1px
                  border-top 1px dashed #eee
                  margin-top 15px
                }
                &:first-child{
                  .list_oneBox{
                    display block
                  }
                  .list_twoBox{
                    display none
                  }
                }

                .list_oneBox{
                  display none
                  cursor: pointer
                  .list_top{
                    display flex
                    align-items center
                    >img{
                      width: 69px
                      height: 60px
                      margin-right 20px
                    }
                    >div{
                      font-weight: 700;
                      font-size: 20px;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      width 600px
                    }
                  }
                  .list_textBox{
                    margin-top 20px
                    font-size: 16px;
                    color: #6B6B6B;
                    line-height: 24px;
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                  }
                }

                .list_twoBox{
                  cursor: pointer
                  .list_twoBox_Q{
                    display flex
                    align-items center
                    >div{
                      width: 30px
                      height: 30px
                      border-radius: 5px;
                      background #1083f8
                      font-weight: 700;
                      font-style: normal;
                      font-size: 20px;
                      color: #fff
                      text-align: center
                      line-height:30px
                      margin-right 20px
                    }
                    >span {
                      font-weight: 700;
                      font-style: normal;
                      font-size: 16px;
                      color: #333
                      cursor: pointer
                    }
                  }
                  .list_twoBox_A{
                    margin-top 20px
                    display flex
                    align-items center
                    >div{
                      width: 30px
                      height: 30px
                      border-radius: 5px;
                      background #36a99e
                      font-weight: 700;
                      font-style: normal;
                      font-size: 20px;
                      color: #fff
                      text-align: center
                      line-height:30px
                      margin-right 20px
                    }
                    >span {
                      width 95%
                      font-weight: 700;
                      font-style: normal;
                      font-size: 13px;
                      color: #333
                      line-height: 22px;
                      text-overflow: -o-ellipsis-lastline;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      display: -webkit-box;
                      -webkit-line-clamp: 2;
                      -webkit-box-orient: vertical;
                    }
                  }
                  .list_twoBox_bottom{
                    display flex
                    align-items center
                    .doctor_head{
                      display flex
                      align-items center
                      margin-top 20px
                      >img{
                        width: 80px;
                        height: 80px;
                        border-radius 50%
                        margin-right 15px
                      }
                      .doctor_name{
                        font-weight: 700;
                        font-style: normal;
                        font-size: 18px;
                        color: #000000;
                        margin-right 15px
                        max-width: 90px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                      }
                      .doctor_title{
                        max-width: 120px;
                        padding 0 10px
                        height: 31px;
                        background #1083f8
                        font-size: 16px;
                        color: #fff
                        text-align: center
                        line-height:31px
                        border-radius 5px
                        margin-right 15px
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                      }
                      .doctor_hospital{
                        font-size: 14px;
                        color: #000000;
                        margin-right 15px
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        max-width 150px
                      }
                      .doctor_twoTitle{
                        font-size: 14px;
                        color: #000000;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        max-width 150px
                      }
                    }
                    .doctor_add{
                      width: 174px;
                      height: 25px;
                      border 1px solid #199ed8
                      text-align: center
                      line-height:25px
                      color: #199ED8
                      font-size: 13px;
                      border-radius 5px
                      margin-left  50px
                      cursor: pointer
                    }
                  }
                }
              }
            }
            .card_leftList_bottom{
              display flex
              flex-wrap wrap
              justify-content space-between
              .item_list{
                width: 49%
                display flex
                justify-content space-between
                align-items center
                margin-top 20px
                cursor: pointer
                .left_title{
                  display flex
                  align-items center
                  >img{
                    width: 25px;
                    height: 25px;
                    margin-right 10px
                  }
                  >div{
                    font-size: 16px;
                    color: #333
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    max-width 280px
                  }
                }
                .right_time{
                  font-size: 14px;
                  color: #868686;
                }
              }
            }
          }
          .interact_card_right{
            width: 361px
            .yiQiKan{
              display flex
              justify-content space-between
              align-items center
              >span{
                font-weight: 700;
                font-size: 18px;
                color: #1083F8;
              }
              >div{
                width: 87px;
                height: 29px;
                border 1px solid #1083f8
                line-height 29px
                text-align: center
                cursor: pointer
                font-size: 18px;
                color: #1083F8
              }
            }
            .card_right_list{
              margin-top 27px
              .right_list_item{
                margin-top 17px
                display flex
                align-items center
                cursor: pointer
                &:nth-child(-n+3){
                  display block
                  .item_num{
                    display none
                  }
                  .item_title{
                    display none
                  }
                  .item_oneCard{
                    display flex
                  }
                  &:after {
                    content ''
                    display flex
                    width: 361px
                    height: 1px
                    border-top 1px dashed #eee
                    margin-top 20px
                    transform translateY(-4px)
                  }
                }
                .item_num{
                  width: 35px;
                  height: 29px;
                  text-align: center
                  line-height 29px
                  font-size: 18px;
                  color: #A1A1A1;
                  border 1px solid #e4e4e4
                  margin-right 15px
                }
                .item_title{
                  font-size: 16px;
                  color: #333
                  width 80%
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                .item_oneCard{
                  display none
                  .oneCard_left{
                    position relative
                    >img{
                      width: 148px;
                      height: 83px;
                    }
                    >div{
                      position absolute
                      bottom:3px
                      left: 0
                      width: 35px;
                      height: 29px;
                      text-align: center
                      line-height 29px
                      font-size: 18px;
                      color: #fff;
                      background #ff8a8a
                      margin-right 15px
                    }
                  }
                  .oneCard_right{
                    margin-left 20px
                    width: 185px
                    .header{
                      max-width 200px
                      font-weight: 700;
                      font-size: 18px;
                      color: #333
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    }
                    .title{
                      margin-top 15px
                      max-width 200px
                      display flex
                      >div{
                        font-size: 16px;
                        color: #A1A1A1;
                        max-width: 40%
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        margin-right  10px
                      }
                      >span{
                        font-size: 16px;
                        color: #A1A1A1;
                        max-width: 60%
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                      }
                    }
                    .time{
                      margin-top 15px
                      font-size: 14px;
                      color: #C9C9C9;
                      text-align: right
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .nav_title{
    font-size 20px
    color #000
    display flex
    align-items center
    &:before{
      content ''
      display block
      width: 4px
      height: 20px
      background: #0d83f8
      margin-right 10px
      border-radius 10px
    }
  }
</style>





// WEBPACK FOOTER //
// src/views/Home.vue